import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Search } from "lucide-react";

const pad2 = (n) => String(n).padStart(2, "0");
export const firstOfMonth = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-01`;
export const lastOfMonth = (d) => {
  const l = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return `${l.getFullYear()}-${pad2(l.getMonth() + 1)}-${pad2(l.getDate())}`;
};
export const prevMonthRange = () => {
  const n = new Date();
  const p = new Date(n.getFullYear(), n.getMonth() - 1, 1);
  return [firstOfMonth(p), lastOfMonth(p)];
};

export default function PeriodoPicker({ from, to, onChange, onRun, loading }) {
  const now = new Date();
  const presets = [
    { k: "prev", label: "Mese precedente", range: prevMonthRange() },
    { k: "cur", label: "Mese corrente", range: [firstOfMonth(now), lastOfMonth(now)] },
    { k: "week", label: "Ultimi 7 giorni", range: [new Date(now.getTime() - 6 * 864e5).toISOString().slice(0, 10), now.toISOString().slice(0, 10)] },
  ];
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="controllo-periodo">
      <div className="flex gap-1">
        {presets.map((p) => (
          <Button key={p.k} type="button" size="sm" variant={from === p.range[0] && to === p.range[1] ? "default" : "outline"}
            onClick={() => onChange(p.range[0], p.range[1])} data-testid={`controllo-preset-${p.k}`}>
            {p.label}
          </Button>
        ))}
      </div>
      <div className="flex items-center gap-1 text-sm">
        <span className="text-slate-500">dal</span>
        <Input type="date" value={from} onChange={(e) => onChange(e.target.value, to)} className="h-9 w-[150px]" data-testid="controllo-date-from" />
        <span className="text-slate-500">al</span>
        <Input type="date" value={to} onChange={(e) => onChange(from, e.target.value)} className="h-9 w-[150px]" data-testid="controllo-date-to" />
      </div>
      <Button type="button" onClick={onRun} disabled={loading || !from || !to} className="bg-[#0044FF] hover:bg-[#0033CC]" data-testid="controllo-run-btn">
        {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Search className="h-4 w-4 mr-2" />}
        Analizza periodo
      </Button>
    </div>
  );
}
